@if(row.nbrAudio==1){
  <app-media-player-button
    [faIcon]="faIcon"
    [playOnClick]="true"
    [currentChant]="getDefaultMedia(row)"
    [currentchantMediaAudioMergeList]="row.chantMediaAudioMerge"
    [currentChantDeperanceList]="currentChantDeperanceList"
    ></app-media-player-button>
}
@if(row.nbrAudio>1){
  <span [matBadge]="row.nbrAudio<=1? '':row.nbrAudio"
    matBadgeOverlap="true" matBadgeColor="warn" matBadgeSize="small"
    [matMenuTriggerFor]="matMenuOptionsAudio" matBadgePosition="before">
      <app-media-player-button
        [faIcon]="faIcon"
        [playOnClick]="false"
        [currentChant]="getDefaultMedia(row)"
        [currentchantMediaAudioMergeList]="row.chantMediaAudioMerge"
        [currentChantDeperanceList]="currentChantDeperanceList"
        ></app-media-player-button>
  </span>
  <mat-menu #matMenuOptionsAudio="matMenu" class="profile-menu onTop">
    <div class="noti-list onTop">
      <div class="menu ">
        <div class="user_dw_menu">
          <app-media-player-button
            [playOnClick]="true"
            [showMatMenu]="true"
            *ngFor="let item of row.chantMediaAudioMerge; let i = index; trackBy: trackByFn"
            [label]="'Melodie ' + (i+1).toString()"
            [label1]="item.artistName"
            [label2]="item.genreName"
            [currentChant]="item"
            [currentchantMediaAudioMergeList]="row.chantMediaAudioMerge"
            [currentChantDeperanceList]="currentChantDeperanceList"
            >
          </app-media-player-button>
      </div>
      </div>
    </div>
  </mat-menu>
}
